import React from 'react';
import NodeSymbolSelect from './NodeSymbolSelect';
import { Handle, Position } from 'reactflow';

export default function TrendlineNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #dc2626',
      background: 'var(--card)',
      minWidth: 220,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#ef4444' }}>
        📐 Trendline
      </div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <div style={{ display: 'flex', gap: 6, marginBottom: 6 }}>
        <select
          value={data.type || 'resistance'}
          onChange={(e) => onChange('type', e.target.value)}
          style={{ flex: 1, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
        >
          <option value="resistance">Resistance</option>
          <option value="support">Support</option>
        </select>
        <input
          type="number"
          min={2}
          value={data.min_touches ?? 3}
          onChange={(e) => onChange('min_touches', Math.max(2, parseInt(e.target.value, 10) || 3))}
          style={{ width: 64, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <label style={{ fontSize: 11, color: 'var(--muted)' }}>Lookback</label>
        <input
          type="number"
          min={10}
          value={data.lookback ?? 100}
          onChange={(e) => onChange('lookback', Math.max(10, parseInt(e.target.value, 10) || 100))}
          style={{ width: 74, padding: 3, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
        />
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#dc2626' }} />
    </div>
  );
}
